// document.addEventListener('DOMContentLoaded', function () {
//   const items = document.querySelectorAll('[data-scroll]');

//   if (!items.length) return;

//   const observer = new IntersectionObserver(function (entries, obs) {
//     entries.forEach(function (entry) {
//       if (!entry.isIntersecting) return;

//       entry.target.classList.add('is-visible');
//       obs.unobserve(entry.target);
//     });
//   }, {
//     threshold: 0.18,
//     rootMargin: '0px 0px -8% 0px'
//   });

//   items.forEach(function (item) {
//     observer.observe(item);
//   });
// });

document.addEventListener('DOMContentLoaded', function () {

  const items = document.querySelectorAll('[data-scroll]');

  if (!items.length) return;

  const observer = new IntersectionObserver(function (entries) {

    entries.forEach(function (entry) {

      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.remove('is-visible');
      }

    });

  }, {
    threshold: 0.18,
    rootMargin: '0px 0px -8% 0px'
  });

  items.forEach(function (item) {
    observer.observe(item);
  });

});